/*
 * Space Cart — tiroir panier maison (29/08).
 * Remplace UpCart. Toutes les données viennent de /cart.js : le tiroir est re-rendu
 * après CHAQUE modification du panier, d'où qu'elle vienne (thème, cross-sell,
 * ou app Free Gift Box qui ajoute le cadeau toute seule).
 * On ne touche à rien dans le tunnel de paiement : « Passer commande » est le
 * POST /cart?checkout standard du thème.
 */
(function () {
  'use strict';

  var CFG = window.SpaceCartConfig || {};
  var THRESHOLD = typeof CFG.threshold === 'number' ? CFG.threshold : 7000;
  var CART_URL = CFG.cartUrl || '/cart';
  var ADD_URL = CFG.addUrl || '/cart/add';
  var CHANGE_URL = CFG.changeUrl || '/cart/change';
  var UPDATE_URL = CFG.updateUrl || '/cart/update';
  var FALLBACK_COLLECTION = CFG.fallbackCollection || 'best-seller';

  /* =====================================================================
   * RÈGLES DE CROSS-SELL « CHOISI ENSEMBLE » — validées produit par produit
   * par Enzo le 01/09, revues par Enzo le 14/10/2026 (fleurs, résines,
   * cartouches, puffs, packs découverte). Tout est modifiable ici sans
   * toucher au reste du code.
   *
   * Une règle = des `types` de produits + des `slots`, dans l'ordre.
   * Options de règle :
   *   max      -> nombre de cartes (5 par défaut) ; les places restantes sont
   *               comblées par les compléments automatiques Shopify
   *   shuffle  -> l'ordre des slots est mélangé à chaque visite (packs)
   * Types de slots :
   *   handle      -> un produit précis
   *   random      -> tirage au sort dans `options` (un élément peut être
   *                  lui-même un tableau : tirage à deux étages ; ou un objet
   *                  { collection, … } comme dans une chaîne de replis)
   *   collection  -> `pick` = top | second | bottom | random | newest dans une
   *                  collection (ou la 1re non vide d'une liste), filtrable
   *                  par `types`, `typePrefix`, `titlePrefix`, `vendor`,
   *                  `maxPrice`
   *   brandCartridge -> cartouche de la MÊME marque que la ligne dominante
   *                  (même fournisseur) ; 14/10 (Enzo) : si la marque n'a plus
   *                  d'autre cartouche en stock, la case saute, on ne met pas
   *                  une autre marque à la place
   *
   * « Populaire » = premier disponible dans l'ordre de la collection.
   * « Moins populaire » = tirage dans la seconde moitié (ou le dernier).
   * « newest » (la nouveauté) = le produit publié le plus récemment. Avec
   * `recentDays`, les produits sortis dans les N jours autour du plus récent
   * comptent aussi comme nouveautés : tirage au sort entre eux.
   * Les tirages au sort sont STABLES pendant une visite (voir creeAlea()) :
   * un +1 sur une quantité ne rebat pas les cartes.
   * Un slot vide (rupture, brouillon, déjà au panier) est remplacé par le
   * complément automatique Shopify : jamais de trou.
   * ===================================================================== */

  // Marques : appartenance réelle à la collection d'abord, titre en repli.
  var BRANDS = [
    { name: 'Cali Farms', collection: 'califarms-los-angeles', match: /cali\s*-?\s*farms/i },
    { name: 'Cookies',    collection: 'univers-cookies',       match: /cookies/i }
  ];
  var CARTRIDGES_COLLECTION = 'vape-cartridges';

  /* Replis « même famille » réutilisés par plusieurs slots. */
  var ACCESSOIRES = 'accessoires-pour-fumeurs-cbd-raw-cookies-grollz';   // « Produits pour fumeurs »
  var REPLI_ACCESSOIRE_FUMEUR = { collection: ACCESSOIRES, maxPrice: 1500, pick: 'top' };
  var REPLI_LAISSES = ['laisses-a-briquet', 'laisse-a-briquet-spacecbd-dispensary',
                       REPLI_ACCESSOIRE_FUMEUR];

  /* Briques communes aux règles fleurs et résines (Enzo, 14/10/2026). */
  // Un blunt Hemper, n'importe quel goût (Nature, Sweet, Miel, Myrtille,
  // Raisin, Mangue…), tiré au sort -> les minis embout verre -> accessoire < 15 €
  var SLOT_BLUNT_HEMPER = { kind: 'collection', collection: ACCESSOIRES,
    vendor: 'Hemper', types: ['Blunt'], titlePrefix: 'Hemp Rolls King Size', pick: 'random',
    fallbacks: ['hemp-rolls-mini-embout-verre-hemper', REPLI_ACCESSOIRE_FUMEUR] };
  // Un plateau à rouler, n'importe quelle marque, tiré au sort
  var SLOT_PLATEAU = { kind: 'collection', collection: ACCESSOIRES,
    types: ['Plateau à rouler'], pick: 'random',
    fallbacks: [REPLI_ACCESSOIRE_FUMEUR] };
  // Feuilles slim noir RAW, 2,00 € -> autres feuilles RAW -> accessoire fumeur < 15 €
  var SLOT_RAW_NOIR = { kind: 'handle', handle: 'raw-slim-noir',
    fallbacks: [{ collection: 'raw', maxPrice: 1500, pick: 'top' }, REPLI_ACCESSOIRE_FUMEUR] };

  var SLOTS_FLEURS = [
    // Tips en verre Hemper x7 : fiche à créer (handle réservé ci-dessous). Tant
    // qu'elle n'est pas en ligne : les feuilles King Size + 10 embouts verre
    // Hemper, puis les cônes embout verre Hemper, puis un accessoire < 15 €.
    { kind: 'handle', handle: 'glass-tips-x7-hemper',
      fallbacks: ['feuilles-king-size-10-embouts-verre-hemper',
                  'cones-king-size-embout-verre-hemper', REPLI_ACCESSOIRE_FUMEUR] },
    SLOT_RAW_NOIR,
    SLOT_BLUNT_HEMPER,
    // Un Clipper Space CBD, couleur au sort (vert, orange, rouge) -> l'ancien Clipper
    { kind: 'random', options: ['clipper-space-cbd-vert', 'clipper-space-cbd-orange',
                                'clipper-space-cbd-rouge'],
      fallbacks: ['clipper-space', REPLI_ACCESSOIRE_FUMEUR] },
    SLOT_PLATEAU,
    // Un grinder Space CBD, au sort (les deux bleus New Shop / Montmartre, le
    // métal 4 étages) -> le plastique à couleurs -> un grinder, n'importe quelle marque
    { kind: 'random', options: ['grinder-plastique-space-cbd-bleu-new-shop',
                                'grinder-plastique-space-cbd-bleu-montmartre',
                                'grinder-metal-4-etages-space'],
      fallbacks: ['grinder-plastique-spacecbd-1',
                  { collection: ACCESSOIRES, types: ['Grinder'], pick: 'top' }] }
  ];

  var SLOTS_RESINES = [
    // Filtres Purize x Space CBD, 12,50 € -> autre filtre/feuille < 15 €
    { kind: 'handle', handle: 'purize-space-cbd',
      fallbacks: [REPLI_ACCESSOIRE_FUMEUR] },
    // 50/50 : les feuilles RAW noir OU des feuilles Space CBD (au sort entre
    // les quatre : Slim + Tips, Space Dispensary, carnets New Store et Rolling Paper)
    { kind: 'random', options: ['raw-slim-noir',
        ['slim-tips-space-cbd', 'feuilles-space-dispensary',
         'carnet-de-feuilles-a-rouler-space-cbd-new-store',
         'carnet-de-feuilles-a-rouler-space-cbd-rolling-paper']],
      fallbacks: [{ collection: 'raw', maxPrice: 1500, pick: 'top' }, REPLI_ACCESSOIRE_FUMEUR] },
    SLOT_PLATEAU,
    SLOT_BLUNT_HEMPER
  ];

  /* Packs découverte (Enzo, 14/10/2026) : un mélange de fleurs et de résines,
     tiré au sort, dans un ordre mélangé. Les fiches ont plusieurs poids : la
     carte renvoie vers la fiche (« Voir »), comme toujours pour ces produits. */
  var FLEURS_AU_SORT = { collection: ['cbd', 'nos-fleurs-cbd'], pick: 'random' };
  var RESINES_AU_SORT = { collection: 'resines-extractions-cbd', pick: 'random' };
  var SLOTS_PACKS = [
    { kind: 'collection', collection: FLEURS_AU_SORT.collection, pick: 'random',
      fallbacks: [RESINES_AU_SORT] },
    { kind: 'collection', collection: RESINES_AU_SORT.collection, pick: 'random',
      fallbacks: [FLEURS_AU_SORT] },
    { kind: 'collection', collection: FLEURS_AU_SORT.collection, pick: 'random',
      fallbacks: [RESINES_AU_SORT] },
    { kind: 'collection', collection: RESINES_AU_SORT.collection, pick: 'random',
      fallbacks: [FLEURS_AU_SORT] },
    { kind: 'random', options: [FLEURS_AU_SORT, RESINES_AU_SORT] }
  ];

  /* --------------------------------------------------------------------
   * PRODUITS-CADEAUX — jamais proposés en cross-sell, ni en ciblé ni en
   * automatique. Ce sont des produits de rachat fidélité / des offres, pas
   * des produits à vendre. Le filtre est appliqué dans usable(), donc il
   * couvre les DEUX étages (règles ciblées ET recommandations Shopify /
   * best-seller). Pour ajouter une exception : une ligne ici, rien d'autre.
   * -------------------------------------------------------------------- */
  var EXCLUS_CROSS_SELL = {
    titres: [
      /cadeau\s*fid[eé]lit[eé]/i,
      /pack\s*fid[eé]lit[eé]/i,
      /🎁/,
      /\boffert(e|s|es)?\b/i,
      /\bgratuit(e|s|es)?\b/i
    ],
    handles: ['greenhouse-cbd-offert-10-gr', 'greenhouse-cbd-gratuit']
  };

  function estProduitCadeau(p) {
    if (!p) return false;
    if (p.handle && EXCLUS_CROSS_SELL.handles.indexOf(p.handle) !== -1) return true;
    var t = p.title || '';
    for (var i = 0; i < EXCLUS_CROSS_SELL.titres.length; i++) {
      if (EXCLUS_CROSS_SELL.titres[i].test(t)) return true;
    }
    return false;
  }

  /* --------------------------------------------------------- cadeau auto */
  // 10 gr de GreenHouse offerts dès 70 € de fleurs & résines. L'ajout et le
  // retrait sont automatiques : c'est un ajout « type app », il n'ouvre pas le
  // tiroir. La gratuité elle-même vient d'une remise automatique Shopify ; ce
  // script ne fait que poser la ligne, il ne fixe aucun prix.
  var CADEAU = {
    variantId: 57578410672476,          // GreenHouse CBD, variante 10gr
    productHandle: 'greenhouse-cbd',
    seuil: 7000,                        // 70 € éligibles
    // 12/10/2026 : `nos-fleurs-cbd` a été masquée de la boutique en ligne le
    // 09/10 (SEO) : sa liste publique est vide, donc les fleurs n'étaient plus
    // comptées et le cadeau n'était plus posé. `cbd` la remplace ici (mêmes
    // fleurs, classées par type). L'ancienne reste en tête de liste : si elle
    // revient en ligne, rien à changer. La remise Shopify compte toujours
    // `nos-fleurs-cbd` côté serveur ; si les deux listes divergeaient un jour,
    // le garde-fou plus bas retire la ligne cadeau payante.
    collections: ['nos-fleurs-cbd', 'cbd', 'resines-extractions-cbd', 'pack-decouverte-cbd']
  };
  // GreenHouse CBD est lui-même dans `nos-fleurs-cbd` : un client peut acheter
  // ce 10 gr de son plein gré. On marque donc NOS lignes d'une propriété
  // (préfixe `_` = masquée par Shopify) pour ne jamais toucher la sienne.
  var CADEAU_PROP = '_cadeau';
  var CADEAU_PROP_VAL = 'greenhouse-70';
  var CADEAU_FLAG = 'spcart:cadeau-ko';   // sessionStorage : ne plus réessayer

  /* --------------------------------------------------- paliers quantité (info)
   * Les remises automatiques Shopify « Fast bundle » (3 -> -8 %, 5 -> -12 %,
   * 10 -> -15 % sur ces 3 collections) font le calcul RÉEL. Ce bloc ne sert
   * qu'à INFORMER le client de sa progression : il n'applique aucune remise.
   * Modifiable ici sans toucher au moteur.
   * `label`     : nom complet de la famille (référence)
   * `labelCourt`: version affichée dans le tiroir, où la place est comptée.
   * -------------------------------------------------------------------- */
  var PALIERS = {
    collections: ['califarms-los-angeles', 'vape-puff-cookies', 'puffy'],
    seuils: [ { min: 3, pct: 8 }, { min: 5, pct: 12 }, { min: 10, pct: 15 } ],
    label: 'Cali Farms & Cookies',
    labelCourt: 'Cali/Cookies'
  };

  var CROSS_SELL_RULES = [
    { label: 'R1 — Cartouches', why: 'Va avec ta cartouche',
      types: ['Cartouche', 'Cartouche Live Resin'],
      slots: [
        // CCELL -> autres batteries du mapping -> cartouche populaire
        { kind: 'handle', handle: 'batterie-pen-ccell',
          fallbacks: ['batterie-califarms', 'batterie-kodo',
                      { collection: 'vape-cartridges', typePrefix: 'Cartouche', pick: 'top' }] },
        // 2 cartouches de la même marque ; plus de stock chez la marque = cases vides
        { kind: 'brandCartridge', pick: 'top' },
        { kind: 'brandCartridge', pick: 'bottom' },
        // 14/10 (Enzo) : en 4e, une cartouche ajoutée récemment ; s'il y en a
        // plusieurs (sorties à moins de 30 jours d'écart), ça change d'une visite à l'autre.
        { kind: 'collection', collection: 'vape-cartridges', typePrefix: 'Cartouche',
          pick: 'newest', recentDays: 30 }
      ] },

    { label: 'R2 — Puffs', why: 'Dans le même délire',
      types: ['Puff'],
      slots: [
        // 14/10 (Enzo) : la nouveauté du rayon en premier (la puff publiée le
        // plus récemment, hors celle déjà au panier).
        { kind: 'collection', collection: 'puff-cbd', pick: 'newest' },
        { kind: 'collection', collection: 'puff-cbd', pick: 'top' },
        // Le slot précédent est déjà retiré de la liste : « top » donne donc ici
        // la puff juste en dessous, c'est-à-dire « un peu moins populaire ».
        { kind: 'collection', collection: 'puff-cbd', pick: 'top' },
        { kind: 'brandCartridge', pick: 'top' }
      ] },

    // 14/10 (Enzo) : 6 produits choisis, donc 6 cartes, pas de complément automatique
    { label: 'R3 — Fleurs', why: 'Pour ta session',
      types: ['Fleur CBD', 'Fleur CBD+', 'Fleurs', 'CBD'],
      max: 6,
      slots: SLOTS_FLEURS },

    { label: 'R4 — Résines / CBC', why: 'Pour ta session',
      types: ['Résine', 'Résine CBD', 'Résine CBD+', 'CBC'],
      slots: SLOTS_RESINES },

    { label: 'R5 — Gummies / Brownie / Sirop', why: 'Le combo munchies',
      types: ['Gummies', 'Brownie', 'Sirop'],
      slots: [
        // Double Cup -> le plus vendu de la catégorie de la règle (edibles)
        { kind: 'handle', handle: 'double-cup',
          fallbacks: [{ collection: 'best-seller', types: ['Gummies', 'Brownie', 'Sirop'], pick: 'top' },
                      { collection: 'space-gummies-cbd-collector', pick: 'top' }] },
        // Sprite US - Tropical Mix, 15 € -> autre boisson populaire
        { kind: 'handle', handle: 'sprite-tropical-mix',
          fallbacks: [{ collection: 'boissons-du-monde', pick: 'top' }] },
        // Seule `space-gummies-cbd-collector` est publiée sur la boutique en ligne.
        // `gummies-cbd` et `brownies-cookies-cbd-collector` ont été dépubliées
        // volontairement — attente législation, ne pas réintégrer.
        // L'autre Space Gummies sort tout seul (la liste exclut déjà l'indisponible).
        { kind: 'collection', collection: 'space-gummies-cbd-collector',
          titlePrefix: 'Space Gummies', pick: 'random' }
      ] },

    { label: 'R6 — Boissons / Alimentation', why: 'Le combo',
      types: ['Boisson', 'Alimentation', 'Alimentation, boissons et tabac', 'New York Seltzer'],
      slots: [
        // Double Cup -> le plus vendu de la catégorie de la règle (boissons)
        { kind: 'handle', handle: 'double-cup',
          fallbacks: [{ collection: 'best-seller',
                        types: ['Boisson', 'Alimentation', 'Alimentation, boissons et tabac',
                                'New York Seltzer'],
                        pick: 'top' },
                      { collection: 'boissons-du-monde', pick: 'top' }] },
        { kind: 'handle', handle: 'laisse-a-briquet-space-cbd-v2', fallbacks: REPLI_LAISSES },
        // la boisson suivante sort tout seul (la liste exclut déjà l'indisponible)
        { kind: 'collection', collection: 'boissons-du-monde', pick: 'top' }
      ] },

    { label: 'R7 — Accessoires', why: 'De quoi les utiliser',
      types: ['Accessoire', 'Blunt', 'Bang', 'Grinder', 'Feuilles à rouler', 'Cône', 'Filtres et tips', 'Plateau à rouler', 'Cendrier', 'Briquet', 'Rangement', 'Batterie'],
      slots: [
        { kind: 'handle', handle: 'maracuja-cbd',
          fallbacks: [{ collection: ['cbd', 'nos-fleurs-cbd'], pick: 'top' }] },
        // = Bruce Banner CBD+ (14/10 : l'ancien handle `skunky-thcx` n'existe
        // plus, la fiche est `bruce-banner-cbd-plus`)
        { kind: 'handle', handle: 'bruce-banner-cbd-plus',
          fallbacks: ['skunky-thcx', { collection: ['cbd', 'nos-fleurs-cbd'], pick: 'top' }] },
        // = GMO Static CBD+
        { kind: 'handle', handle: 'gmo-static-cbc',
          fallbacks: [{ collection: 'resines-extractions-cbd', pick: 'top' }] }
      ] },

    { label: 'R8 — Merch', why: 'Le pack Space',
      types: ['Merch'],
      slots: [
        // Double Cup -> le plus vendu de la catégorie de la règle (merch).
        // `best-seller` ne contient aucun Merch au 01/09 : c'est `merch-2025` qui répond.
        { kind: 'handle', handle: 'double-cup',
          fallbacks: [{ collection: 'best-seller', types: ['Merch'], pick: 'top' },
                      { collection: 'merch-2025', pick: 'top' }] },
        { kind: 'handle', handle: 'casquette-trucker-spacecbd',
          fallbacks: [{ collection: 'merch-2025', pick: 'top' }] },
        { kind: 'handle', handle: 'laisse-a-briquet-space-cbd-v2', fallbacks: REPLI_LAISSES }
      ] },

    // 14/10 (Enzo) : un pack au panier -> 5 fleurs et résines au sort, ordre mélangé
    { label: 'R9 — Packs découverte', why: 'Pour continuer la découverte',
      types: ['Pack découverte'],
      shuffle: true,
      slots: SLOTS_PACKS }

    // R10 — Huile CBD, Infusion, Parapharmacie, Savon, Soin : aucune règle,
    // donc 5 suggestions automatiques Shopify.
  ];
  // 5 cartes (sauf `max` sur la règle) : les slots de la règle ciblée, puis
  // des compléments automatiques. La rangée en montre ~3, les suivantes se
  // découvrent au doigt.
  var RECO_MAX = 5;

  // On garde une référence non patchée : nos propres appels ne doivent pas
  // re-déclencher l'observateur de modifications du panier.
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;

  var el = {};
  var cart = null;
  var busy = false;
  var lastIntentAt = 0;
  var lastFocused = null;
  var prevTotal = null;
  var celebratedThisOpening = false;
  var noteTimer = null;
  var productCache = {};
  var cadeauIds = null;                 // ids produits des 2 collections éligibles
  var cadeauBusy = false;               // une seule opération cadeau à la fois
  var cadeauDerniereTentative = null;   // anti-boucle : 1 essai par état de panier
  var palierIds = null;                 // ids produits des collections à paliers
  var undoData = null;                  // dernière suppression annulable
  var undoTimer = null;
  var recoSnapTimer = null;             // remise du scroll-snap après un défilement

  /* ---------------------------------------------------------------- utils */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(cents) {
    var fmt = CFG.moneyFormat || '€{{amount_with_comma_separator}}';
    var n = (Number(cents) || 0) / 100;
    var neg = n < 0;
    var abs = Math.abs(n);
    function build(decimalSep, thousandSep, decimals) {
      var parts = abs.toFixed(decimals).split('.');
      var out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
      if (decimals && parts[1]) out += decimalSep + parts[1];
      return (neg ? '-' : '') + out;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount_no_decimals': return build('.', ',', 0);
        case 'amount_with_comma_separator': return build(',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return build(',', '.', 0);
        case 'amount_with_apostrophe_separator': return build('.', "'", 2);
        case 'amount_no_decimals_with_space_separator': return build(',', ' ', 0);
        case 'amount_with_space_separator': return build(',', ' ', 2);
        default: return build('.', ',', 2);
      }
    });
  }

  // « €70 » plutôt que « €70,00 » — réservé aux badges compacts.
  function moneyShort(cents) {
    return money(cents).replace(/[.,]00(\D*)$/, '$1');
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function jsonPost(url, body) {
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data && data.description ? data.description : 'Erreur panier');
        return data;
      });
    });
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* --------------------------------------------------------------- ouvrir */

  function open() {
    if (!el.root) return;
    lastFocused = document.activeElement;
    celebratedThisOpening = false;
    el.root.hidden = false;
    void el.root.offsetWidth; // reflow : la transition part de l'état fermé
    el.root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (el.panel) el.panel.focus();
    updateFab();
    refresh(false);
  }

  function close() {
    if (!el.root) return;
    hideUndo();
    el.root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!el.root.classList.contains('is-open')) el.root.hidden = true;
      updateFab();
    }, 300);
    if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} }
  }

  function isOpen() { return !!(el.root && el.root.classList.contains('is-open')); }

  function setBusy(v) {
    busy = v;
    if (el.root) el.root.classList.toggle('is-busy', !!v);
  }

  /* ------------------------------------------------- badge & bouton flottant */

  function bubble(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var b = link.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!b) {
        b = document.createElement('div');
        b.className = 'cart-count-bubble';
        b.innerHTML = '<span aria-hidden="true"></span>';
        link.appendChild(b);
      }
      var s = b.querySelector('span[aria-hidden]');
      if (s) s.textContent = count < 100 ? String(count) : '';
    } else if (b) {
      b.parentNode.removeChild(b);
    }
  }

  function updateFab() {
    if (!el.fab) return;
    var count = cart ? cart.item_count : 0;
    if (el.fabCount) el.fabCount.textContent = count < 100 ? String(count) : '99+';
    el.fab.hidden = (count === 0) || isOpen();
  }

  /* ------------------------------------------------------- livraison offerte */

  function renderShipping(total) {
    if (!el.ship) return;
    if (!cart || !cart.items || !cart.items.length) { el.ship.hidden = true; return; }
    el.ship.hidden = false;
    var remaining = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / THRESHOLD) * 100)));
    var msg, badge;
    // ⓘ vers la politique d'expédition : le 70 € ne vaut qu'en métropole.
    // Nouvel onglet, sinon le client perd son panier ouvert.
    var info = ' <a class="spcart__ship-info" href="/policies/shipping-policy"'
      + ' target="_blank" rel="noopener"'
      + ' aria-label="Voir les conditions de livraison">ⓘ</a>';
    if (remaining > 0) {
      // La fusee de la piste raconte deja la progression : pas d'emoji ici.
      msg = 'Plus que ' + esc(money(remaining)) + ' pour la livraison offerte en France métropolitaine' + info;
      badge = esc(moneyShort(THRESHOLD));
      el.ship.classList.remove('is-unlocked');
    } else {
      msg = '🎉 Livraison offerte en France métropolitaine débloquée !' + info;
      badge = esc(moneyShort(THRESHOLD)) + ' ✓';
      el.ship.classList.add('is-unlocked');
      pct = 100;
    }
    // La fusée marque l'extrémité du remplissage. Bornée pour rester dans la
    // piste aux deux extrémités — le calcul du seuil, lui, ne change pas.
    var fusee = Math.max(4, Math.min(96, pct));
    el.ship.innerHTML =
      '<div class="spcart__ship-head">' +
        '<p class="spcart__ship-msg">' + msg + '</p>' +
        '<span class="spcart__ship-badge">' + badge + '</span>' +
      '</div>' +
      '<div class="spcart__ship-track">' +
        '<span class="spcart__ship-fill" style="width:' + pct + '%"></span>' +
        '<span class="spcart__ship-rocket" style="left:' + fusee + '%" aria-hidden="true">🚀</span>' +
      '</div>';

    // Animation au moment PRÉCIS du franchissement, une seule fois par ouverture.
    var crossed = prevTotal !== null && prevTotal < THRESHOLD && total >= THRESHOLD;
    if (crossed && isOpen() && !celebratedThisOpening) {
      celebratedThisOpening = true;
      confetti();
    }
    prevTotal = total;
  }

  function confetti() {
    if (!el.confetti || reducedMotion()) return;
    var colors = ['#FFD23F', '#8FD2FF', '#0D2B4F', '#FFFFFF'];
    var html = '';
    for (var i = 0; i < 30; i++) {
      var left = Math.round(Math.random() * 100);
      var delay = (Math.random() * 0.4).toFixed(2);
      var color = colors[i % colors.length];
      html += '<span style="left:' + left + '%;background:' + color +
        ';animation-delay:' + delay + 's"></span>';
    }
    el.confetti.innerHTML = html;
    setTimeout(function () { if (el.confetti) el.confetti.innerHTML = ''; }, 2000);
  }

  /* ---------------------------------------------------------------- lignes */

  function itemHtml(item, line) {
    var gift = Number(item.final_price) === 0;
    var img = item.image
      ? '<img class="spcart__thumb" src="' + esc(sized(item.image, 150)) + '" alt="" loading="lazy" width="72" height="72">'
      : '<div class="spcart__thumb spcart__thumb--ph" aria-hidden="true">🛍️</div>';

    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="spcart__variant">' + esc(item.variant_title) + '</span>' : '';

    var price;
    if (gift) {
      price = '<span class="spcart__price">Offert</span>';
    } else if (Number(item.original_line_price) > Number(item.final_line_price)) {
      price = '<span class="spcart__price"><del>' + esc(money(item.original_line_price)) + '</del>' +
        esc(money(item.final_line_price)) + '</span>';
    } else {
      price = '<span class="spcart__price">' + esc(money(item.final_line_price)) + '</span>';
    }

    var controls, remove;
    if (gift) {
      // Cadeau géré par l'app Free Gift Box : ni quantité, ni suppression.
      controls = '<span class="spcart__gift">🎁 Cadeau débloqué</span>';
      remove = '';
    } else {
      controls =
        '<div class="spcart__qty">' +
        '<button type="button" data-spcart-qty="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Retirer une unité">−</button>' +
        '<span class="spcart__qty-val">' + item.quantity + '</span>' +
        '<button type="button" data-spcart-qty="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Ajouter une unité">+</button>' +
        '</div>';
      remove = '<button type="button" class="spcart__remove" data-spcart-qty="' + line + '" data-qty="0">Retirer</button>';
    }

    return '<li class="spcart__item' + (gift ? ' is-gift' : '') + '">' +
      '<a href="' + esc(item.url || '#') + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="spcart__info">' +
      '<a class="spcart__name" href="' + esc(item.url || '#') + '">' + esc(item.product_title || item.title) + '</a>' +
      variant +
      '<div class="spcart__line">' + controls + price + '</div>' +
      remove +
      '</div></li>';
  }

  /* --------------------------------------------------- code promo & note */

  // Une remise est déjà posée sur au moins une ligne (barème quantité, promo
  // produit…). La ligne cadeau ne compte pas : sa remise à elle est automatique
  // et n'a rien à voir avec un non-cumul.
  function panierDejaRemise() {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (estLigneCadeau(items[i])) continue;
      var all = items[i].line_level_discount_allocations;
      if (all && all.length) return true;
    }
    return false;
  }

  function renderPromo() {
    if (!el.promoState) return;
    var codes = (cart && cart.discount_codes) || [];
    if (!codes.length) { el.promoState.innerHTML = ''; el.promoState.className = 'spcart__promo-state'; return; }
    el.promoState.className = 'spcart__promo-state';
    var dejaRemise = panierDejaRemise();
    el.promoState.innerHTML = codes.map(function (c) {
      if (c.applicable) {
        return '<span class="spcart__chip">✓ ' + esc(c.code) +
          ' — enregistré, il s’appliquera au paiement' +
          '<button type="button" data-spcart-promo-remove>Retirer</button></span>';
      }
      // Code refusé alors qu'une remise est déjà appliquée : c'est un non-cumul,
      // pas un code mort. On le dit clairement plutôt que d'inquiéter le client.
      if (dejaRemise) {
        return '<span class="spcart__promo-state is-ko">' +
          'Ce code ne se cumule pas avec ta remise quantité déjà appliquée — ' +
          't’as déjà le meilleur tarif 👌 ' +
          '<button type="button" data-spcart-promo-remove>Retirer</button></span>';
      }
      return '<span class="spcart__promo-state is-ko">« ' + esc(c.code) +
        ' » n’est pas valide ou n’est plus actif. ' +
        '<button type="button" data-spcart-promo-remove>Retirer</button></span>';
    }).join('');
  }

  function applyPromo() {
    if (!el.promoInput) return;
    var code = (el.promoInput.value || '').trim();
    if (!code) return;
    if (el.promoApply) el.promoApply.disabled = true;
    el.promoState.className = 'spcart__promo-state';
    el.promoState.textContent = 'Vérification…';
    // /discount/<CODE> enregistre le code côté Shopify ; la remise elle-même
    // n'est calculée qu'au checkout, on ne simule donc aucun montant ici.
    rawFetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' })
      .then(function () { return refresh(false); })
      .then(function () {
        if (el.promoInput) el.promoInput.value = '';
      })
      .catch(function () {
        el.promoState.className = 'spcart__promo-state is-ko';
        el.promoState.textContent = 'Impossible de vérifier ce code pour le moment.';
      })
      .then(function () { if (el.promoApply) el.promoApply.disabled = false; });
  }

  function removePromo() {
    jsonPost(UPDATE_URL + '.js', { discount: '' })
      .then(function () { return refresh(false); })
      .catch(function () {});
  }

  function saveNote(value) {
    if (!el.noteState) return;
    el.noteState.textContent = 'Enregistrement…';
    jsonPost(UPDATE_URL + '.js', { note: value })
      .then(function (data) {
        cart = data;
        el.noteState.textContent = value ? '✓ Note enregistrée' : '';
      })
      .catch(function () { el.noteState.textContent = 'Note non enregistrée, réessaie.'; });
  }

  /* --------------------------------------- progression : cadeau puis paliers */

  // Ids produits des collections à paliers quantité (mêmes caches que le reste).
  function idsPaliers() {
    if (palierIds) return Promise.resolve(palierIds);
    var ids = {};
    var i = 0;
    function step() {
      if (i >= PALIERS.collections.length) { palierIds = ids; return ids; }
      return getCollection(PALIERS.collections[i++]).then(function (list) {
        for (var k = 0; k < list.length; k++) { if (list[k] && list[k].id) ids[list[k].id] = true; }
        return step();
      });
    }
    return Promise.resolve().then(step);
  }

  function renderGiftProgress(etat) {
    if (!el.giftRow) return;
    var texte = null;
    if (etat.eligible && etat.lignes.length) {
      texte = 'Tes 10 g de GreenHouse sont dans le panier !';
    } else if (!etat.eligible && etat.total > 0) {
      texte = 'Encore ' + money(CADEAU.seuil - etat.total) +
              ' de fleurs, résines ou packs pour tes 10 g offerts';
    }
    // Aucun article éligible au panier : on ne pousse pas des fleurs à
    // quelqu'un qui achète des sodas. Et on referme le « comment ça marche ? ».
    if (!texte) {
      el.giftRow.hidden = true;
      if (el.howPanel) el.howPanel.hidden = true;
      if (el.howToggle) el.howToggle.setAttribute('aria-expanded', 'false');
      return;
    }
    if (el.gift) el.gift.textContent = texte;
    el.giftRow.hidden = false;
  }

  function renderTiers() {
    if (!el.tier || !el.tierRow) return Promise.resolve();
    var items = (cart && cart.items) || [];
    if (!items.length) { el.tierRow.hidden = true; return Promise.resolve(); }
    return idsPaliers().then(function (ids) {
      if (!el.tier || !el.tierRow) return;
      var qte = 0;
      for (var i = 0; i < items.length; i++) {
        if (estLigneCadeau(items[i])) continue;
        if (ids[items[i].product_id]) qte += Number(items[i].quantity) || 0;
      }
      if (!qte) { el.tierRow.hidden = true; return; }

      var seuils = PALIERS.seuils || [];
      var atteint = null, suivant = null;
      for (var k = 0; k < seuils.length; k++) {
        if (qte >= seuils[k].min) atteint = seuils[k];
        else { suivant = seuils[k]; break; }
      }
      var manque = suivant ? (suivant.min - qte) : 0;
      var txt;
      if (!atteint && suivant) {
        txt = 'Encore ' + manque + ' article' + (manque > 1 ? 's' : '') + ' ' +
              PALIERS.labelCourt + ' pour −' + suivant.pct + ' %';
      } else if (atteint && suivant) {
        txt = '−' + atteint.pct + ' % appliqués ✓ · encore ' + manque +
              ' pour −' + suivant.pct + ' %';
      } else if (atteint) {
        txt = '−' + atteint.pct + ' % appliqués sur tes ' + PALIERS.labelCourt + ' ✓';
      } else {
        el.tierRow.hidden = true; return;
      }
      el.tier.textContent = txt;
      el.tierRow.hidden = false;
    }).catch(function () { if (el.tierRow) el.tierRow.hidden = true; });
  }

  function renderProgress() {
    if (!el.progress) return;
    var items = (cart && cart.items) || [];
    if (!items.length) { el.progress.hidden = true; return; }
    idsCadeau()
      .then(function (ids) { renderGiftProgress(analyseCadeau(ids)); return renderTiers(); })
      .then(function () {
        if (!el.progress) return;
        var rienAAfficher = (!el.giftRow || el.giftRow.hidden) && (!el.tierRow || el.tierRow.hidden);
        el.progress.hidden = rienAAfficher;
      })
      .catch(function () { if (el.progress) el.progress.hidden = true; });
  }

  /* ------------------------------------------------ économies & points fidélité */

  // original_total_price - total_price : paliers, remises code ET le cadeau
  // (dont les 30 € du GreenHouse) sont donc comptés d'un coup, sans recalcul.
  // Le calcul n'a pas changé ; seul le libellé a été refait, « Tu économises »
  // n'étant pas compris. La mention du cadeau n'apparaît que si la ligne
  // `_cadeau` est réellement au panier.
  function renderSavings() {
    if (!el.savings) return;
    var eco = (Number(cart && cart.original_total_price) || 0) -
              (Number(cart && cart.total_price) || 0);
    if (eco <= 0) { el.savings.hidden = true; return; }
    var items = (cart && cart.items) || [];
    var avecCadeau = false;
    for (var i = 0; i < items.length; i++) {
      if (estLigneCadeau(items[i])) { avecCadeau = true; break; }
    }
    el.savings.innerHTML = '🎉 −' + esc(money(eco)) + ' de remises sur ta commande' +
      (avecCadeau ? ' <span class="spcart__savings-note">(cadeau 10 g inclus)</span>' : '');
    el.savings.hidden = false;
  }

  // Règle publique Space Team : 1 € dépensé = 1 point, sur le total APRÈS
  // remises — d'où le « ~ », le décompte final restant celui de Smile.
  function renderPoints() {
    if (!el.points) return;
    var pts = Math.floor((Number(cart && cart.total_price) || 0) / 100);
    if (pts > 0) {
      el.points.textContent = '⭐ Cette commande te rapporte ~' + pts + ' points Space Team';
      el.points.hidden = false;
    } else {
      el.points.hidden = true;
    }
  }

  /* ------------------------------------------------- annuler une suppression */

  function itemDeLigne(line) {
    var items = (cart && cart.items) || [];
    return items[line - 1] || null;
  }

  function hideUndo() {
    clearTimeout(undoTimer);
    undoTimer = null;
    undoData = null;
    if (el.undo) el.undo.hidden = true;
  }

  // Une seule annulation mémorisée à la fois : la plus récente.
  function armeUndo(item) {
    if (!el.undo || !item || estLigneCadeau(item)) return;
    var vid = Number(item.variant_id || item.id);
    if (!vid) return;
    undoData = { id: vid, quantity: Number(item.quantity) || 1 };
    el.undo.hidden = false;
    clearTimeout(undoTimer);
    undoTimer = setTimeout(hideUndo, 5000);
  }

  function annuleSuppression() {
    if (!undoData || busy) return;
    var d = undoData;
    hideUndo();
    setBusy(true);
    jsonPost(ADD_URL + '.js', { id: d.id, quantity: d.quantity })
      .then(function () { return refresh(false); })
      .catch(function (e) { showError(e.message || 'Impossible de remettre ce produit.'); })
      .then(function () { setBusy(false); });
  }

  /* ------------------------------------------------------- délai d'expédition */

  function renderCutoff() {
    if (!el.cutoff) return;
    // Heure de Paris, quel que soit le fuseau du visiteur. Lun–ven, coupure 15 h.
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', hour12: false
      }).formatToParts(new Date());
    } catch (e) { el.cutoff.textContent = ''; return; }
    var get = function (t) { var p = parts.filter(function (x) { return x.type === t; })[0]; return p ? p.value : ''; };
    var day = get('weekday');
    var hour = parseInt(get('hour'), 10);
    var openDay = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(day) !== -1;
    el.cutoff.textContent = (openDay && hour < 15)
      ? 'Commande avant 15h : ton colis part aujourd’hui 🚀'
      : 'Ton colis part le prochain jour ouvré';
  }

  /* ---------------------------------------------------------------- rendu */

  function render() {
    if (!el.root || !cart) return;
    if (el.loading) el.loading.hidden = true;

    var items = cart.items || [];
    if (el.items) {
      el.items.innerHTML = items.map(function (it, i) { return itemHtml(it, i + 1); }).join('');
    }
    if (el.empty) el.empty.hidden = items.length > 0;
    if (el.foot) el.foot.hidden = items.length === 0;
    // Les infos secondaires ont quitté le pied pour la zone défilante : elles
    // se masquent avec lui quand le panier est vide.
    if (el.infos) el.infos.hidden = items.length === 0;
    if (el.subtotal) el.subtotal.textContent = money(cart.total_price);
    if (el.noteInput && document.activeElement !== el.noteInput) {
      el.noteInput.value = cart.note || '';
    }

    renderShipping(cart.total_price);
    renderProgress();
    renderSavings();
    renderPoints();
    renderPromo();
    renderCutoff();
    bubble(cart.item_count);
    updateFab();
    loadReco();
    syncCadeau();
  }

  function showError(msg) {
    if (!el.body) return;
    var prev = el.body.querySelector('.spcart__err');
    if (prev) prev.parentNode.removeChild(prev);
    var p = document.createElement('p');
    p.className = 'spcart__err';
    p.textContent = msg;
    el.body.appendChild(p);
  }

  /* ------------------------------------------------------------ cross-sell */

  function normalize(p, mode, targeted) {
    var variants = p.variants || [];
    var available = variants.filter(function (v) { return v.available !== false; });
    var v = available[0] || variants[0] || null;
    var price;
    if (mode === 'cents') {
      price = p.price != null ? Number(p.price) : (v ? Number(v.price) : 0);
    } else {
      price = Math.round(parseFloat((v && v.price) || p.price || 0) * 100);
    }
    var img = p.featured_image ||
      (p.images && p.images[0] ? (p.images[0].src || p.images[0]) : null);
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      url: p.url || ('/products/' + p.handle),
      price: price,
      img: img,
      variantId: v ? v.id : null,
      multi: variants.length > 1,
      available: available.length > 0 && p.available !== false,
      // Date de publication (listes de collection) : sert à « la nouveauté »
      publishedAt: Date.parse(p.published_at || '') || 0,
      vendor: p.vendor || '',
      targeted: !!targeted
    };
  }

  function getProduct(handle) {
    if (productCache[handle] !== undefined) return Promise.resolve(productCache[handle]);
    return rawFetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { productCache[handle] = null; return null; });
  }

  function getCollection(handle) {
    var key = 'col:' + handle;
    if (productCache[key] !== undefined) return Promise.resolve(productCache[key]);
    return rawFetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { productCache[key] = d.products || []; return productCache[key]; })
      .catch(function () { productCache[key] = []; return []; });
  }

  /* --- Étage a : la règle ciblée de la famille dominante du panier --- */

  /* Tirage au sort STABLE pendant la visite (14/10/2026, Enzo). Les
     suggestions tirées au sort (goût du blunt, couleur du Clipper, plateau,
     fleurs et résines des packs…) ne doivent pas changer à chaque mouvement du
     panier (+1, −1, ajout d'une suggestion). Une graine est tirée une fois par
     visite (sessionStorage) ; chaque calcul des suggestions repart de cette
     graine avec SA PROPRE suite de nombres (creeAlea) : deux calculs qui se
     chevauchent (le tiroir est rafraîchi deux fois après un ajout) ne se volent
     pas leurs tirages, et le même panier donne toujours les mêmes cartes. Deux
     visiteurs n'ont pas la même graine : le hasard reste du hasard. En
     navigation privée sans stockage, la graine vaut pour la page. */
  var GRAINE_CLE = 'spcart:graine';
  var graineVisite = 0;

  function graine() {
    if (graineVisite) return graineVisite;
    var g = 0;
    try { g = parseInt(window.sessionStorage.getItem(GRAINE_CLE), 10) || 0; } catch (e) { g = 0; }
    if (!g) {
      g = Math.floor(Math.random() * 2147483646) + 1;
      try { window.sessionStorage.setItem(GRAINE_CLE, String(g)); } catch (e) { /* pas de stockage */ }
    }
    graineVisite = g;
    return g;
  }

  // Générateur de nombres pseudo-aléatoires (mulberry32), une instance par calcul.
  function creeAlea(seed) {
    var s = seed >>> 0;
    return function () {
      s = (s + 0x6D2B79F5) >>> 0;
      var t = s;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  // Un nombre entre 0 et 1 : la suite stable du calcul en cours, sinon le hasard du navigateur.
  function hasard(ctx) {
    return (ctx && ctx.alea) ? ctx.alea() : Math.random();
  }

  function pickRandom(arr, ctx) { return arr[Math.floor(hasard(ctx) * arr.length)]; }
  function isArray(x) { return Object.prototype.toString.call(x) === '[object Array]'; }

  // Mélange (Fisher-Yates) avec le même hasard stable.
  function melange(arr, ctx) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(hasard(ctx) * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  // Hook de simulation : depuis la console,
  //   window.SpaceCartDebug = { unavailable: ['handle-a', 'handle-b'] }
  // fait passer ces produits pour indisponibles, afin de tester les chaînes de
  // remplacement sans mettre de vrais produits en brouillon. En production la
  // variable n'existe pas : aucun effet.
  function simuleIndispo(handle) {
    var d = window.SpaceCartDebug;
    return !!(d && d.unavailable && handle && d.unavailable.indexOf(handle) !== -1);
  }

  function usable(p, ctx) {
    if (!p || !p.available || !p.id) return false;
    if (simuleIndispo(p.handle)) return false;          // hook de simulation
    if (estProduitCadeau(p)) return false;              // aucun produit-cadeau
    if (ctx.used[p.id]) return false;                   // pas de doublon
    if (ctx.inCart.indexOf(p.id) !== -1) return false;  // pas déjà au panier
    return true;
  }

  // Première collection non vide de la liste (repli si l'une n'est pas publiée).
  function firstNonEmptyCollection(handles) {
    var i = 0;
    function step() {
      if (i >= handles.length) return Promise.resolve([]);
      return getCollection(handles[i++]).then(function (list) {
        return list.length ? list : step();
      });
    }
    return step();
  }

  function pickFromList(raw, slot, ctx) {
    var list = raw || [];
    if (slot.typePrefix) {
      var re = new RegExp('^' + slot.typePrefix, 'i');
      list = list.filter(function (p) { return re.test(p.product_type || ''); });
    }
    if (slot.types) {
      list = list.filter(function (p) { return slot.types.indexOf(p.product_type || '') !== -1; });
    }
    if (slot.vendor) {
      var marque = String(slot.vendor).toLowerCase();
      list = list.filter(function (p) { return String(p.vendor || '').toLowerCase() === marque; });
    }
    var items = list.map(function (p) { return normalize(p, 'decimal', true); })
                    .filter(function (p) { return usable(p, ctx); });
    if (slot.titlePrefix) {
      items = items.filter(function (p) { return (p.title || '').indexOf(slot.titlePrefix) === 0; });
    }
    if (slot.maxPrice) {
      items = items.filter(function (p) { return p.price > 0 && p.price < slot.maxPrice; });
    }
    if (!items.length) return null;

    var pick = slot.pick || 'top';
    if (pick === 'top') return items[0];
    if (pick === 'second') return items[1] || items[0];
    if (pick === 'random') return pickRandom(items, ctx);
    if (pick === 'newest') {
      // « La nouveauté » : le produit publié le plus récemment. Avec
      // `recentDays`, ceux sortis à moins de N jours du plus récent comptent
      // aussi : tirage au sort entre eux, ça change d'une visite à l'autre.
      var tries = items.slice().sort(function (a, b) { return (b.publishedAt || 0) - (a.publishedAt || 0); });
      var plancher = (tries[0].publishedAt || 0) - (slot.recentDays || 0) * 86400000;
      var recents = tries.filter(function (p) { return (p.publishedAt || 0) >= plancher; });
      return recents.length > 1 ? pickRandom(recents, ctx) : tries[0];
    }
    // « bottom » = moins populaire : tirage dans la seconde moitié, sinon le dernier.
    if (items.length >= 4) return pickRandom(items.slice(Math.ceil(items.length / 2)), ctx);
    return items[items.length - 1];
  }

  /* Une « entrée » de chaîne est soit un handle (chaîne de caractères), soit un
     objet { collection, types?, typePrefix?, titlePrefix?, vendor?, maxPrice?,
     pick?, recentDays? }. */
  function resolveEntry(entry, ctx) {
    if (typeof entry === 'string') {
      return getProduct(entry).then(function (p) {
        if (!p) return null;
        var n = normalize(p, 'cents', true);
        return usable(n, ctx) ? n : null;
      });
    }
    if (entry && entry.collection) {
      var cols = isArray(entry.collection) ? entry.collection : [entry.collection];
      return firstNonEmptyCollection(cols).then(function (raw) {
        return pickFromList(raw, entry, ctx);
      });
    }
    return Promise.resolve(null);
  }

  // Descend la chaîne jusqu'au premier produit utilisable.
  function resolveChain(entries, ctx) {
    var i = 0;
    function step() {
      if (i >= entries.length) return Promise.resolve(null);
      return resolveEntry(entries[i++], ctx).then(function (p) { return p || step(); });
    }
    return step();
  }

  function resolveSlot(slot, ctx) {
    var fallbacks = slot.fallbacks || [];

    if (slot.kind === 'handle') {
      return resolveChain([slot.handle].concat(fallbacks), ctx);
    }

    if (slot.kind === 'random') {
      // Tirage au sort, puis on parcourt le RESTE du tirage avant les replis :
      // plateau -> un blunt -> l'autre blunt, ou blunt -> l'autre blunt -> plateau.
      var idx = Math.floor(hasard(ctx) * slot.options.length);
      var ordered = [];
      function push(opt) {
        if (isArray(opt)) {
          var j = Math.floor(hasard(ctx) * opt.length);
          ordered.push(opt[j]);
          for (var k = 0; k < opt.length; k++) if (k !== j) ordered.push(opt[k]);
        } else {
          ordered.push(opt);
        }
      }
      push(slot.options[idx]);
      for (var n = 0; n < slot.options.length; n++) if (n !== idx) push(slot.options[n]);
      return resolveChain(ordered.concat(fallbacks), ctx);
    }

    if (slot.kind === 'collection') {
      return resolveChain([{
        collection: slot.collection, types: slot.types, typePrefix: slot.typePrefix,
        titlePrefix: slot.titlePrefix, vendor: slot.vendor, maxPrice: slot.maxPrice,
        pick: slot.pick, recentDays: slot.recentDays
      }].concat(fallbacks), ctx);
    }

    if (slot.kind === 'brandCartridge') {
      // 14/10 (Enzo) : SEULEMENT la marque de la ligne dominante. D'abord par
      // fournisseur (vendor) dans le rayon cartouches, puis par la collection de
      // la marque si on la connaît. Plus de stock chez la marque = rien : on ne
      // propose jamais une autre marque à la place.
      var entries = [];
      if (ctx.vendor) {
        entries.push({ collection: CARTRIDGES_COLLECTION, typePrefix: 'Cartouche',
                       vendor: ctx.vendor, pick: slot.pick });
      }
      if (ctx.brand) {
        entries.push({ collection: ctx.brand.collection, typePrefix: 'Cartouche', pick: slot.pick });
      }
      if (!entries.length) return Promise.resolve(null);
      return resolveChain(entries.concat(fallbacks), ctx);
    }

    return Promise.resolve(null);
  }

  // Marque de la ligne dominante : appartenance à la collection, sinon titre.
  function detectBrand(item) {
    var title = item.product_title || item.title || '';
    var byTitle = null;
    for (var i = 0; i < BRANDS.length; i++) {
      if (BRANDS[i].match.test(title)) { byTitle = BRANDS[i]; break; }
    }
    var j = 0;
    function step() {
      if (j >= BRANDS.length) return Promise.resolve(byTitle);
      var b = BRANDS[j++];
      return getCollection(b.collection).then(function (list) {
        var inIt = list.some(function (p) { return p.id === item.product_id; });
        return inIt ? b : step();
      });
    }
    return step();
  }

  function targetedSuggestions(items, ctx) {
    // Panier multi-familles : on applique LA règle de la famille de la ligne
    // la plus chère (final_line_price max). Une seule règle à la fois.
    var dominant = items.slice().sort(function (a, b) {
      return (Number(b.final_line_price) || 0) - (Number(a.final_line_price) || 0);
    })[0];
    if (!dominant) return Promise.resolve([]);

    var type = (dominant.product_type || '').trim();
    var rule = null;
    for (var i = 0; i < CROSS_SELL_RULES.length; i++) {
      if (CROSS_SELL_RULES[i].types.indexOf(type) !== -1) { rule = CROSS_SELL_RULES[i]; break; }
    }
    ctx.dominant = dominant.product_title;
    ctx.type = type;
    ctx.vendor = String(dominant.vendor || '').trim();   // fournisseur = marque (Cali Farms, Cookies, Mellow Fellow…)
    ctx.rule = rule ? rule.label : null;
    ctx.max = (rule && rule.max) || RECO_MAX;
    if (!rule) return Promise.resolve([]);

    return detectBrand(dominant).then(function (brand) {
      ctx.brand = brand;
      var out = [];
      var slots = rule.shuffle ? melange(rule.slots, ctx) : rule.slots;
      return slots.reduce(function (chain, slot) {
        return chain.then(function () {
          return resolveSlot(slot, ctx).then(function (p) {
            if (p) { p.why = rule.why || ''; ctx.used[p.id] = true; out.push(p); }
          });
        });
      }, Promise.resolve()).then(function () { return out; });
    });
  }

  // Étage b : recommandations natives, puis collection de repli.
  function nativeSuggestions(seedId) {
    return rawFetch('/recommendations/products.json?product_id=' + seedId + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d.products || []).map(function (p) { return normalize(p, 'cents', false); });
        if (list.length) return list;
        throw new Error('vide');
      })
      .catch(function () {
        return getCollection(FALLBACK_COLLECTION).then(function (list) {
          return list.map(function (p) { return normalize(p, 'decimal', false); });
        });
      });
  }

  function recoCardHtml(p) {
    // Carte verticale : la photo occupe toute la largeur (~112 px, 224 en retina).
    var thumb = p.img
      ? '<img class="spcart__reco-thumb" src="' + esc(sized(p.img, 224)) + '" alt="" loading="lazy" width="112" height="92">'
      : '<div class="spcart__reco-thumb" aria-hidden="true"></div>';
    // Produits à plusieurs variantes (poids, formats) : on renvoie vers la fiche
    // plutôt que d'ajouter une variante au hasard.
    var action = p.multi
      ? '<a class="spcart__reco-btn" href="' + esc(p.url) + '">Voir</a>'
      : '<button type="button" class="spcart__reco-btn" data-spcart-add="' + esc(p.variantId) + '">Ajouter</button>';
    // Le « pourquoi » n'existe que sur les cartes issues d'une règle ciblée :
    // le complément automatique Shopify n'a aucune raison à donner.
    var why = (p.targeted && p.why)
      ? '<div class="spcart__reco-why">' + esc(p.why) + '</div>' : '';
    return '<div class="spcart__reco-card' + (p.targeted ? ' is-targeted' : '') + '">' + thumb +
      '<div class="spcart__reco-info">' +
      '<a class="spcart__reco-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="spcart__reco-price">' + esc(money(p.price)) + '</div>' + why +
      '</div>' + action + '</div>';
  }

  /* --------------------------------- flèches de défilement du cross-sell
   * Ordinateur seulement (>= 750 px) ET seulement si la rangée déborde.
   * Sous 750 px le CSS les masque et le JS ne les montre jamais : le
   * défilement au doigt reste inchangé sur téléphone.
   * ------------------------------------------------------------------- */

  // Un « pas » = la largeur d'une carte + l'écart entre cartes.
  function recoPas() {
    if (!el.recoList) return 140;
    var carte = el.recoList.querySelector('.spcart__reco-card');
    if (!carte) return 140;
    var st = window.getComputedStyle(el.recoList);
    var gap = parseFloat(st.columnGap || st.gap || '') || 8;
    return Math.round(carte.getBoundingClientRect().width + gap);
  }

  function majRecoNav() {
    if (!el.recoList || !el.recoPrev || !el.recoNext) return;
    var surOrdinateur = window.innerWidth >= 750;
    var deborde = el.recoList.scrollWidth - el.recoList.clientWidth;
    if (!surOrdinateur || deborde <= 2) {
      el.recoPrev.hidden = true;
      el.recoNext.hidden = true;
      return;
    }
    var x = el.recoList.scrollLeft;
    el.recoPrev.hidden = x <= 2;
    el.recoNext.hidden = x >= deborde - 2;
  }

  function defileReco(sens) {
    if (!el.recoList) return;
    var l = el.recoList;
    var max = l.scrollWidth - l.clientWidth;
    var depart = l.scrollLeft;
    var cible = Math.max(0, Math.min(max, depart + sens * recoPas()));
    if (cible === depart) { majRecoNav(); return; }

    // Mouvement réduit demandé, ou navigateur sans scrollTo : on saute direct.
    if (reducedMotion() || !l.scrollTo) {
      l.scrollLeft = cible;
      majRecoNav();
      return;
    }

    // Le scroll-snap neutralise le défilement animé sur plusieurs navigateurs :
    // on le suspend le temps du trajet, puis on le rend au doigt.
    l.style.scrollSnapType = 'none';
    l.scrollTo({ left: cible, behavior: 'smooth' });
    clearTimeout(recoSnapTimer);
    recoSnapTimer = setTimeout(function () {
      // Filet : si l'animation n'a rien déplacé (moteur qui l'ignore), on pose
      // la position directement — une flèche doit toujours faire son travail.
      if (Math.abs(l.scrollLeft - depart) < 2 && Math.abs(cible - depart) > 2) {
        l.scrollLeft = cible;
      }
      l.style.scrollSnapType = '';
      majRecoNav();
    }, 420);
  }

  function loadReco() {
    if (!el.reco) return;
    var items = (cart && cart.items) || [];
    if (!items.length) { el.reco.hidden = true; return; }

    var inCart = items.map(function (i) { return i.product_id; });
    var ctx = { used: {}, inCart: inCart, brand: null, vendor: '', rule: null, max: RECO_MAX,
                alea: creeAlea(graine()) };   // même panier, mêmes tirages au sort, toute la visite

    // Le complément automatique ne doit reprendre ni le panier, ni les ciblées.
    var keep = function (p) {
      if (!usable(p, ctx)) return false;
      ctx.used[p.id] = true;
      return true;
    };

    targetedSuggestions(items, ctx).then(function (targeted) {
      var max = ctx.max || RECO_MAX;
      var list = targeted.slice(0, max);
      if (list.length >= max) return list;
      // Places restantes : recommandations Shopify, puis `best-seller`.
      return nativeSuggestions(inCart[0]).then(function (native) {
        list = list.concat(native.filter(keep)).slice(0, max);
        if (list.length >= max) return list;
        // Dernier recours : on complète avec la collection de repli. Utile quand
        // le filtrage (produits-cadeaux, ruptures) a vidé les recommandations.
        return getCollection(FALLBACK_COLLECTION).then(function (raw) {
          var extra = raw.map(function (p) { return normalize(p, 'decimal', false); })
                         .filter(keep);
          return list.concat(extra).slice(0, max);
        });
      });
    }).then(function (list) {
      // Trace de diagnostic (règle appliquée, marque détectée) — lisible en console.
      window.SpaceCart && (window.SpaceCart.lastReco = {
        regle: ctx.rule, familleDominante: ctx.type, ligneDominante: ctx.dominant,
        marque: ctx.brand ? ctx.brand.name : null, fournisseur: ctx.vendor || null,
        suggestions: list.map(function (p) { return { titre: p.title, ciblee: p.targeted }; })
      });
      if (!list.length) { el.reco.hidden = true; majRecoNav(); return; }
      el.recoList.innerHTML = list.map(recoCardHtml).join('');
      el.reco.hidden = false;
      el.recoList.scrollLeft = 0;
      majRecoNav();
    }).catch(function () { el.reco.hidden = true; majRecoNav(); });
  }

  /* ------------------------------------------------------------- données */

  function refresh(openAfter) {
    return rawFetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
        if (openAfter && !isOpen()) open();
        return data;
      })
      .catch(function () { /* réseau : on garde l'état précédent */ });
  }

  // `undoItem` : la ligne telle qu'elle était AVANT le retrait, pour pouvoir
  // la remettre. Renseignée uniquement par le bouton « Retirer ».
  function changeLine(line, qty, undoItem) {
    if (busy) return;
    setBusy(true);
    jsonPost(CHANGE_URL + '.js', { line: line, quantity: qty })
      .then(function (data) { cart = data; render(); if (undoItem) armeUndo(undoItem); })
      .catch(function (e) { showError(e.message || 'Impossible de mettre à jour le panier.'); })
      .then(function () { setBusy(false); });
  }

  function addVariant(id, btn) {
    if (busy) return;
    setBusy(true);
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    jsonPost(ADD_URL + '.js', { id: Number(id), quantity: 1 })
      .then(function () { return refresh(false); })
      .catch(function (e) { showError(e.message || 'Impossible d’ajouter ce produit.'); })
      .then(function () { setBusy(false); });
  }

  /* --------------------------------------------------- cadeau automatique */

  function cadeauEcarte() {
    try { return sessionStorage.getItem(CADEAU_FLAG) === '1'; } catch (e) { return false; }
  }
  function ecarteCadeau() {
    try { sessionStorage.setItem(CADEAU_FLAG, '1'); } catch (e) { /* mode privé */ }
  }

  // Une ligne cadeau = notre variante ET notre marque. Une ligne que le client
  // a ajoutée lui-même n'a pas la propriété : on n'y touche jamais.
  function estLigneCadeau(item) {
    if (!item) return false;
    if (Number(item.variant_id || item.id) !== CADEAU.variantId) return false;
    var pr = item.properties;
    return !!(pr && pr[CADEAU_PROP] === CADEAU_PROP_VAL);
  }

  // Ids des produits des deux collections éligibles (via getCollection, en cache).
  function idsCadeau() {
    if (cadeauIds) return Promise.resolve(cadeauIds);
    var ids = {};
    var i = 0;
    function step() {
      if (i >= CADEAU.collections.length) { cadeauIds = ids; return ids; }
      return getCollection(CADEAU.collections[i++]).then(function (list) {
        for (var k = 0; k < list.length; k++) { if (list[k] && list[k].id) ids[list[k].id] = true; }
        return step();
      });
    }
    return Promise.resolve().then(step);
  }

  /* Somme éligible au cadeau (lignes des collections fleurs + résines, la ligne
     cadeau elle-même exclue) et repérage des lignes cadeau. UNE seule
     implémentation, partagée par le moteur du cadeau (syncCadeau) et par la
     ligne de progression affichée au client (renderGiftProgress). */
  function analyseCadeau(ids) {
    var items = (cart && cart.items) || [];
    var lignes = [];
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      if (estLigneCadeau(items[i])) { lignes.push(i + 1); continue; }
      if (ids[items[i].product_id]) total += Number(items[i].final_line_price) || 0;
    }
    return { total: total, lignes: lignes, eligible: total >= CADEAU.seuil };
  }

  // Empreinte de l'état du panier : sert d'anti-boucle (une seule tentative
  // d'ajout par changement réel de panier).
  function empreinteCadeau() {
    var items = (cart && cart.items) || [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      out.push((items[i].key || items[i].id) + 'x' + items[i].quantity);
    }
    return out.join('|');
  }

  function retireLigneCadeau(line) {
    cadeauBusy = true;
    return jsonPost(CHANGE_URL + '.js', { line: line, quantity: 0 })
      .then(function (data) { cart = data; render(); })
      .catch(function () { /* on retentera au prochain rendu */ })
      .then(function () { cadeauBusy = false; syncCadeau(); });
  }

  function ajouteCadeau() {
    cadeauBusy = true;
    var props = {};
    props[CADEAU_PROP] = CADEAU_PROP_VAL;
    return jsonPost(ADD_URL + '.js',
        { id: CADEAU.variantId, quantity: 1, properties: props })
      .then(function () { return refresh(false); })
      .catch(function () {
        // Rupture de stock, variante retirée, erreur réseau : on n'insiste pas.
        ecarteCadeau();
      })
      .then(function () { cadeauBusy = false; syncCadeau(); });
  }

  function syncCadeau() {
    if (!cart || cadeauBusy) return;

    idsCadeau().then(function (ids) {
      if (!cart || cadeauBusy) return;
      var items = cart.items || [];
      var etat = analyseCadeau(ids);
      var lignes = etat.lignes;
      var eligible = etat.eligible;
      var i;

      // GARDE-FOU ABSOLU : le client ne paie JAMAIS le cadeau. Dès que la ligne
      // ressort à un prix > 0, on la retire — sans exception.
      for (i = 0; i < lignes.length; i++) {
        if (Number(items[lignes[i] - 1].final_price) > 0) {
          // Payante alors que le panier est ENCORE éligible : la remise ne joue
          // pas (inactive, non applicable, non cumulable). Là on renonce pour
          // la session, sinon on bouclerait à chaque rendu.
          // Payante parce qu'on vient de repasser SOUS le seuil : c'est une
          // simple transition, on retire sans condamner la session — le client
          // qui remonte au-dessus de 70 € doit retrouver son cadeau. On efface
          // donc l'empreinte de la dernière tentative : sans ça, un panier qui
          // revient EXACTEMENT à son état d'avant serait reconnu comme « déjà
          // tenté » et ne redonnerait plus jamais le cadeau avant rechargement.
          // Aucun risque de boucle : on est !eligible, donc aucune tentative
          // ne part tant que le panier n'est pas repassé au-dessus du seuil.
          if (eligible) ecarteCadeau();
          else cadeauDerniereTentative = null;
          retireLigneCadeau(lignes[i]);
          return;
        }
      }
      // Jamais deux lignes cadeau.
      if (lignes.length > 1) { retireLigneCadeau(lignes[lignes.length - 1]); return; }

      var ligneCadeau = lignes.length ? lignes[0] : 0;
      if (eligible && !ligneCadeau) {
        if (cadeauEcarte()) return;
        var sig = empreinteCadeau();
        if (sig === cadeauDerniereTentative) return;
        cadeauDerniereTentative = sig;
        ajouteCadeau();
      } else if (!eligible && ligneCadeau) {
        cadeauDerniereTentative = null;
        retireLigneCadeau(ligneCadeau);
      }
    });
  }

  /* --------------------------------------------- observation du panier */

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }
  function isAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  function onExternalChange(url) {
    // Ouverture automatique seulement si le changement suit une action de
    // l'utilisateur : un ajout fait par une app (cadeau) ne doit pas ouvrir le tiroir.
    var userDriven = isAdd(url) && (Date.now() - lastIntentAt) < 3000;
    setTimeout(function () { refresh(userDriven); }, 60);
  }

  function patchNetwork() {
    if (window.fetch && rawFetch) {
      window.fetch = function () {
        var input = arguments[0];
        var url = (input && input.url) ? input.url : String(input || '');
        var p = rawFetch.apply(null, arguments);
        if (isCartMutation(url)) {
          p.then(function (res) { if (!res || res.ok !== false) onExternalChange(url); })
            .catch(function () {});
        }
        return p;
      };
    }

    var open_ = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__spcartUrl = url;
      return open_.apply(this, arguments);
    };
    var send_ = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      if (isCartMutation(self.__spcartUrl)) {
        self.addEventListener('load', function () {
          if (self.status >= 200 && self.status < 300) onExternalChange(self.__spcartUrl);
        });
      }
      return send_.apply(this, arguments);
    };
  }

  /* ------------------------------------------------------------ écoutes */

  function toggleSection(btn, panel) {
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  }

  function bind() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var opener = e.target.closest('#cart-icon-bubble, [data-spcart-open]');
      if (opener) { e.preventDefault(); open(); return; }

      if (!el.root) return;

      if (e.target.closest('[data-spcart-close]')) { e.preventDefault(); close(); return; }

      var qtyBtn = e.target.closest('[data-spcart-qty]');
      if (qtyBtn && el.root.contains(qtyBtn)) {
        e.preventDefault();
        var ligne = parseInt(qtyBtn.getAttribute('data-spcart-qty'), 10);
        var quantite = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        // Toute descente à zéro ouvre une annulation, qu'elle vienne du bouton
        // « Retirer » ou du « − » du stepper : c'est la même perte pour le
        // client. armeUndo() refuse la ligne cadeau (estLigneCadeau), qui n'a
        // de toute façon ni stepper ni bouton Retirer.
        var aAnnuler = (quantite === 0) ? itemDeLigne(ligne) : null;
        changeLine(ligne, quantite, aAnnuler);
        return;
      }

      if (e.target.closest('[data-spcart-undo-btn]')) { e.preventDefault(); annuleSuppression(); return; }

      if (e.target.closest('[data-spcart-reco-prev]')) { e.preventDefault(); defileReco(-1); return; }
      if (e.target.closest('[data-spcart-reco-next]')) { e.preventDefault(); defileReco(1); return; }

      if (e.target.closest('[data-spcart-how-toggle]')) {
        e.preventDefault();
        toggleSection(el.howToggle, el.howPanel);
        return;
      }

      var addBtn = e.target.closest('[data-spcart-add]');
      if (addBtn && el.root.contains(addBtn)) {
        e.preventDefault();
        addVariant(addBtn.getAttribute('data-spcart-add'), addBtn);
        return;
      }

      if (e.target.closest('[data-spcart-promo-toggle]')) {
        toggleSection(el.promoToggle, el.promoPanel);
        if (!el.promoPanel.hidden && el.promoInput) el.promoInput.focus();
        return;
      }
      if (e.target.closest('[data-spcart-promo-apply]')) { applyPromo(); return; }
      if (e.target.closest('[data-spcart-promo-remove]')) { removePromo(); return; }

      if (e.target.closest('[data-spcart-note-toggle]')) {
        toggleSection(el.noteToggle, el.notePanel);
        if (!el.notePanel.hidden && el.noteInput) el.noteInput.focus();
        return;
      }
    });

    if (el.promoInput) {
      el.promoInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyPromo(); }
      });
    }

    if (el.noteInput) {
      el.noteInput.addEventListener('input', function () {
        clearTimeout(noteTimer);
        var v = el.noteInput.value;
        noteTimer = setTimeout(function () { saveNote(v); }, 700);
      });
      el.noteInput.addEventListener('blur', function () {
        clearTimeout(noteTimer);
        if ((cart && (cart.note || '')) !== el.noteInput.value) saveNote(el.noteInput.value);
      });
    }

    // Mémorise une intention utilisateur d'ajout (clic sur un bouton d'ajout).
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('form[action*="/cart/add"], [name="add"], .product-form__submit')) {
        lastIntentAt = Date.now();
      }
    }, true);

    // Formulaires d'ajout non gérés par <product-form> (apps, blocs tiers).
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.closest('product-form')) return; // le thème s'en charge déjà
      e.preventDefault();
      lastIntentAt = Date.now();
      rawFetch(ADD_URL + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function () { refresh(true); })
        .catch(function () { showError('Impossible d’ajouter ce produit.'); });
    }, true);

    // La rangée reco pilote l'affichage de ses propres flèches.
    if (el.recoList) {
      var recoTick = false;
      el.recoList.addEventListener('scroll', function () {
        if (recoTick) return;
        recoTick = true;
        window.requestAnimationFrame(function () { recoTick = false; majRecoNav(); });
      }, { passive: true });
    }
    window.addEventListener('resize', majRecoNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    // Le cadeau Free Gift Box peut être ajouté hors de la page : on resynchronise.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh(false);
    });
    window.addEventListener('pageshow', function () { refresh(false); });
  }

  /* ---------------------------------------------------------------- init */

  function init() {
    el.root = document.getElementById('space-cart');
    if (!el.root) return;
    el.panel = el.root.querySelector('.spcart__panel');
    el.body = el.root.querySelector('[data-spcart-body]');
    el.items = el.root.querySelector('[data-spcart-items]');
    el.empty = el.root.querySelector('[data-spcart-empty]');
    el.foot = el.root.querySelector('[data-spcart-foot]');
    el.subtotal = el.root.querySelector('[data-spcart-subtotal]');
    el.ship = el.root.querySelector('[data-spcart-ship]');
    el.confetti = el.root.querySelector('[data-spcart-confetti]');
    el.reco = el.root.querySelector('[data-spcart-reco]');
    el.recoList = el.root.querySelector('[data-spcart-reco-list]');
    el.recoPrev = el.root.querySelector('[data-spcart-reco-prev]');
    el.recoNext = el.root.querySelector('[data-spcart-reco-next]');
    el.loading = el.root.querySelector('[data-spcart-loading]');
    el.promoToggle = el.root.querySelector('[data-spcart-promo-toggle]');
    el.promoPanel = el.root.querySelector('[data-spcart-promo-panel]');
    el.promoInput = el.root.querySelector('[data-spcart-promo-input]');
    el.promoApply = el.root.querySelector('[data-spcart-promo-apply]');
    el.promoState = el.root.querySelector('[data-spcart-promo-state]');
    el.noteToggle = el.root.querySelector('[data-spcart-note-toggle]');
    el.notePanel = el.root.querySelector('[data-spcart-note-panel]');
    el.noteInput = el.root.querySelector('[data-spcart-note-input]');
    el.noteState = el.root.querySelector('[data-spcart-note-state]');
    el.cutoff = el.root.querySelector('[data-spcart-cutoff]');
    el.progress = el.root.querySelector('[data-spcart-progress]');
    el.giftRow = el.root.querySelector('[data-spcart-gift-row]');
    el.gift = el.root.querySelector('[data-spcart-gift]');
    el.howToggle = el.root.querySelector('[data-spcart-how-toggle]');
    el.howPanel = el.root.querySelector('[data-spcart-how-panel]');
    el.tier = el.root.querySelector('[data-spcart-tier]');
    el.tierRow = el.root.querySelector('[data-spcart-tier-row]');
    el.infos = el.root.querySelector('[data-spcart-infos]');
    el.savings = el.root.querySelector('[data-spcart-savings]');
    el.points = el.root.querySelector('[data-spcart-points]');
    el.undo = el.root.querySelector('[data-spcart-undo]');
    el.fab = document.querySelector('.spcart-fab');
    el.fabCount = document.querySelector('[data-spcart-fab-count]');

    patchNetwork();
    bind();
    renderCutoff();
    refresh(false);

    window.SpaceCart = { open: open, close: close, refresh: refresh, rules: CROSS_SELL_RULES };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
